module.exports = __webpack_public_path__ + "fonts/+v2LklA6.woff2";